export default function PrivacyContent() {
  return (
    <div className="prose prose-indigo max-w-none">
      <p className="text-gray-600 mb-6">
        <strong>Effective Date:</strong> November 2025<br />
        <strong>Last Updated:</strong> November 2025
      </p>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">1. Introduction</h3>
        <p className="text-gray-700">
          CTE Consultants & General Sales LLC ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use the CTE Course Platform.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">2. Information We Collect</h3>
        <p className="text-gray-700 mb-3">We collect the following types of information:</p>
        
        <h4 className="font-semibold text-gray-900 mb-2">Personal Information:</h4>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
          <li>Name and email address (required for registration)</li>
          <li>Account credentials (password, encrypted)</li>
          <li>Profile information you choose to provide</li>
        </ul>

        <h4 className="font-semibold text-gray-900 mb-2">Usage Information:</h4>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
          <li>Course progress and completion data</li>
          <li>Lab and capstone project submissions</li>
          <li>Learning activity and engagement metrics</li>
          <li>Device and browser information</li>
          <li>IP address and location data</li>
        </ul>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">3. How We Use Your Information</h3>
        <p className="text-gray-700 mb-3">We use your information to:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Provide, maintain, and improve the Platform</li>
          <li>Process your registration and manage your account</li>
          <li>Track your progress and issue certificates</li>
          <li>Communicate with you about your account and courses</li>
          <li>Respond to your comments, questions, and support requests</li>
          <li>Analyze usage patterns to improve our educational content</li>
          <li>Prevent fraud and ensure Platform security</li>
        </ul>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">4. Information Sharing and Disclosure</h3>
        <p className="text-gray-700 mb-3">
          We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li><strong>Service Providers:</strong> With trusted third-party vendors who assist in operating the Platform</li>
          <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
          <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
          <li><strong>With Your Consent:</strong> When you explicitly authorize us to share your information</li>
        </ul>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">5. Data Security</h3>
        <p className="text-gray-700">
          We implement industry-standard security measures to protect your personal information, including encryption, secure servers, and access controls. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">6. Cookies and Tracking Technologies</h3>
        <p className="text-gray-700">
          We use cookies and similar technologies to enhance your experience, analyze usage, and maintain your session. You can control cookie settings through your browser, but disabling cookies may limit Platform functionality.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">7. Data Retention</h3>
        <p className="text-gray-700">
          We retain your personal information for as long as necessary to provide the Platform services and fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">8. Your Rights and Choices</h3>
        <p className="text-gray-700 mb-3">You have the right to:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Access and review your personal information</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your account and data</li>
          <li>Opt out of marketing communications</li>
          <li>Export your data in a portable format</li>
        </ul>
        <p className="text-gray-700 mt-3">
          To exercise these rights, please contact us using the information provided below.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">9. Children's Privacy</h3>
        <p className="text-gray-700">
          The Platform is not intended for users under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware of such collection, we will take steps to delete the information.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">10. Changes to This Privacy Policy</h3>
        <p className="text-gray-700">
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">11. Contact Us</h3>
        <p className="text-gray-700">
          If you have questions about this Privacy Policy or our data practices, please contact:<br />
          <strong>CTE Consultants & General Sales LLC</strong><br />
          Website: <a href="https://www.cteconsultants.net" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-700">www.cteconsultants.net</a>
        </p>
      </section>
    </div>
  );
}
